import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgSettingsGallery({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M13 13.1v.42c0 .7-.56 1.27-1.25 1.27h-10c-.69 0-1.25-.57-1.25-1.27V6.8c0-.7.56-1.26 1.25-1.26h.42V11c0 1.16.93 2.1 2.08 2.1H13zm2.5-2.1V4.26c0-.7-.56-1.26-1.25-1.26h-10C3.56 3 3 3.57 3 4.26V11c0 .7.56 1.26 1.25 1.26h10c.69 0 1.25-.57 1.25-1.26zM7.17 5.53c0 .7-.56 1.26-1.25 1.26-.7 0-1.25-.57-1.25-1.26 0-.7.56-1.27 1.25-1.27s1.25.57 1.25 1.27zM4.67 9.3L6.1 7.85a.31.31 0 01.44 0L7.58 8.9l3.53-3.56a.31.31 0 01.44 0l2.28 2.3v2.95H4.67V9.3z" />
    </svg>
  );
}

SvgSettingsGallery.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgSettingsGallery.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgSettingsGallery svgRef={ref} {...props} />);
export default ForwardRef;
